/* eslint-disable no-console */
import { appStore } from "@app/store/store"
import { RequestError } from "@tecreation/js-state-react"

export const ApiErrorHandler = error => {
	const detectDeviceType = () => (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent) ? "Mobile" : "Desktop")

	if (
		[
			"wrn.Ticket.AlreadyUsed",
			"err.ScanCode.NotFound",
			"wrn.Order.NotFound",
			"wrn.Relation.InvalidRelationSessionToken",
			"Failed to fetch",
			"Load failed",
			"wrn.RelationSessionToken.Expired",
			"NetworkError when attempting to fetch resource.",
		].indexOf(error.message) > -1 ||
		error.message.startsWith("wrn.") ||
		error.message.startsWith("err.VoucherDetail.DateToReached") ||
		(error.url?.includes("/Voucher/Pdf") && error.message == "err.Unexpected") ||
		(error.url?.includes("ScanCode/Check") && error.message?.startsWith("err.Voucher.Blocked"))
	) {
		return
	}

	//Ignore google bot calls
	if (/Googlebot/i.test(window.navigator.userAgent)) {
		return
	}

	if (error instanceof RequestError || error.method === "GET") {
		let type = appStore.get("core.kioskMode") ? "KIOSK" : appStore.get("core.employeeMode") ? "EMPLOYEE" : "FUNNEL"
		var parentUrl = window.location != window.parent.location ? document.referrer : document.location.href

		fetch("/api/connector/error/trace", {
			method: "POST",
			headers: {
				apiKey: appStore.get("settings.connectorKey"),
				"content-type": "application/json; charset=utf-8",
				Authorization: "Bearer " + appStore.get("core.accessToken"),
			},
			body: JSON.stringify({
				uri: error.url,
				message: type + ";" + error.message,
				body: JSON.stringify({
					device: detectDeviceType(),
					userAgent: window.navigator.userAgent,
					funnelToken: appStore.get("settings.funnelToken"),
					origin: parentUrl,
					url: error.url,
					body: error.body,
					params: error.params,
					headers: error.headers,
					localStorage: window.localStorage,
					response: error.response?.data,
					status: error.response?.status,
				}),
				db: false,
				stackTrace: error.stack,
			}),
		}).catch(e => console.error(e))
	}
}
